import { AlertCircle, CircleCheckBig } from 'lucide-react';

type StatusIconProps = {
  status: 'pending' | 'current' | 'completed' | 'error';
  size?: number;
};

export const StatusIcon: React.FC<StatusIconProps> = ({ status, size = 32 }) => {
  switch (status) {
    case 'current':
      return (
        <div className="w-7 h-7 xs:w-8 xs:h-8 text-white animate-spin">
          <img src="/loader.svg" alt="" />
        </div>
      );
    case 'completed':
      return (
        <div className="w-7 h-7 xs:w-8 xs:h-8 text-white [&>svg]:h-7 xs:[&>svg]:h-8  [&>svg]:w-7 xs:[&>svg]:w-8">
          <CircleCheckBig size={size} color="#00D200" />
        </div>
      );
    case 'error':
      return (
        <div className="w-7 h-7 xs:w-8 xs:h-8 text-red-500">
          <AlertCircle size={size} />
        </div>
      );
  }
};